import { z } from "zod";

import { UuidSchema } from "./common.js";

const unique = <T>(values: T[]) => new Set(values).size === values.length;
export const CreateComparisonExportSchema = z
  .object({
    request_id: UuidSchema,
    project_id: UuidSchema,
    quote_request_id: UuidSchema,
    submission_ids: z.array(UuidSchema).min(1).max(12).refine(unique),
    field_keys: z.array(z.string().min(1).max(200)).min(1).max(100).refine(unique),
    audience: z.enum(["advisor", "client"]),
    language: z.enum(["fr", "en"]),
    include_notes: z.boolean().default(false),
    confirmed: z.literal(true),
    expected_snapshot_sha256: z
      .string()
      .regex(/^[0-9a-f]{64}$/)
      .optional(),
  })
  .strict()
  .refine((v) => v.audience !== "client" || !v.include_notes, {
    message: "Internal notes cannot be included in a client export",
  });
export type CreateComparisonExport = z.infer<typeof CreateComparisonExportSchema>;
export const ComparisonExportRowSchema = z.object({
  id: UuidSchema,
  project_id: UuidSchema,
  quote_request_id: UuidSchema,
  version: z.number().int().positive(),
  audience: z.enum(["advisor", "client"]),
  language: z.enum(["fr", "en"]),
  created_at: z.string(),
  pdf_sha256: z.string(),
  xlsx_sha256: z.string(),
});
export type ComparisonExportRow = z.infer<typeof ComparisonExportRowSchema>;
